var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Tooltip,{attrs:{"effect":"customized","popper-class":"custom","placement":"top"}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._t("tooltip-content")],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }